const validate = (Vue, options) => {
  Vue.mixin({
    methods: {
      $trim(str) {
        return str.replace(/(^s*)|(s*$)/g, "");
      },
      $ltrim(str) {
        return str.replace(/(^s*)/g, "");
      },
      $rtrim(str) {
        return str.replace(/(s*$)/g, "");
      },
      $validate(Str, opt) {
        let _this = this;
        return {
          name(rules, value, callback) {
            let val = value;
            const reStr = Str ? Str : "名称";
            if (String(val).length < 2) {
              callback(new Error(reStr + "不能小于2位"));
            } else if (String(val).length > 20) {
              callback(new Error(reStr + "不能多于20位"));
            } else {
              callback();
            }
          },
          null(rules, value, callback) {
            let val = value;
            const reStr = Str ? Str : "请输入/填写/xxx";
            if (val === "") {
              callback(new Error(reStr));
            } else if (Array.isArray(val)) {
              if (val[0]) {
                callback();
              } else {
                callback(new Error(reStr));
              }
            } else if (String(val).length == 0) {
              callback(new Error(reStr));
            } else {
              callback();
            }
          },
          email(rules, value, callback) {
            let val = value;
            // const reg = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[\-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/gi;
            const reg = /^([A-Za-z0-9_\-\.\u4e00-\u9fa5])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,8})$/;
            if (val == "") {
              callback(new Error("请输入邮箱地址"));
            } else if (!reg.test(val)) {
              callback(new Error("请输入正确的邮箱地址!"));
            } else {
              callback();
            }
          },
          tel(rules, value, callback) {
            let val = value;
            const reg = /^1[0-9]{10}$/gi;
            const reStr = Str ? Str : "手机号码";
            if (val == "") {
              callback(new Error("请输入" + reStr));
            } else if (!reg.test(val)) {
              callback(new Error("请输入正确的" + reStr + "!"));
            } else {
              callback();
            }
          }
        };
      }
    }
  });
};

export default validate;



// WEBPACK FOOTER //
// ./src/assets/validate.js